import { ElEmpty } from 'element-plus'
import { useI18n } from 'i18n-utils'
import { DefineComponentProps } from 'utils'
import './EmptyData.scss'

type EmptyDataProps = {
  text?: string
}

export const EmptyData = defineComponent<EmptyDataProps>({
  props: DefineComponentProps<EmptyDataProps>(['text']),
  setup(props) {
    const { t } = useI18n()

    return () => (
      <div class="empty-data">
        <ElEmpty description={props.text || t('暂无数据')}>
          {{
            image: () => (
              <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72" fill="none">
                <path d="M63 21H48V6L63 21Z" fill="var(--colors-bg-button-disabled)" />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M18 6H48V21H63V66H18V6ZM25.5 28.5H55.5V31.5H25.5V28.5ZM55.5 34.5H25.5V37.5H55.5V34.5ZM25.5 40.5H55.5V43.5H25.5V40.5Z"
                  fill="var(--colors-bg-tag-base)"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.6026 48.0784C22.4736 52.4141 30.7896 51.9236 36.1063 46.6061C41.9638 40.7486 41.9638 31.2506 36.1063 25.3931C30.2488 19.5356 20.7508 19.5356 14.8933 25.3931C9.57581 30.7106 9.08531 39.0259 13.4203 44.8969L2.69531 55.6219L5.87756 58.8041L16.6026 48.0784ZM32.9248 43.4246C28.8246 47.5256 22.1766 47.5256 18.0756 43.4246C13.9753 39.3244 13.9753 32.6764 18.0756 28.5754C22.1766 24.4751 28.8246 24.4751 32.9256 28.5754C37.0258 32.6764 37.0258 39.3244 32.9256 43.4254L32.9248 43.4246Z"
                  fill="var(--colors-bg-button-disabled)"
                />
              </svg>
            ),
          }}
        </ElEmpty>
      </div>
    )
  },
})
